import * as React from 'react'

import { Box, Line, Text } from '@factorialco/deprecated-design-system'

interface ImageProps {
  illustration: any
  title?: string
  width?: number
  height?: number
}
interface DescriptionProps {
  description: string
}
type Props = ImageProps & DescriptionProps

function Image({ illustration, title, width = 200, height = 140 }: ImageProps) {
  return <img src={illustration} width={width} height={height} alt={title} title={title} />
}

export default function IllustratedBlankSlate({
  illustration,
  title,
  description,
  width,
  height,
}: Props) {
  return (
    <Box alignItems="center" textAlign="center" paddingY="s64">
      <Box gap="s16" alignItems="center">
        {illustration && (
          <Image illustration={illustration} title={title} width={width} height={height} />
        )}
        <Box gap="s16" alignItems="center">
          {title && <Text.Header2 color="grey1000">{title}</Text.Header2>}
          {description && <Text.Normal color="grey800">{description}</Text.Normal>}
          <Line />
        </Box>
      </Box>
    </Box>
  )
}
